import { Box, Container, Grid } from "@mui/material";
import React from "react";
import about from "../../asset/img/me.svg";
import "./About.css";
import resume from "../../asset/CV/resume.pdf";

const About = () => {
  return (
    <Container sx={{ mt: 15, mb: 10 }}>
      <Grid container spacing={4}>
        <Grid item xs={12} md={5} className="aboutImg">
          <img src={about} alt="About Me" />
        </Grid>
        <Grid item xs={12} md={7} className="content">
          <h2 className="about-heading">About Me</h2>
          <p>
            Experienced Software Developer with over 4 years of expertise in
            frontend development, specializing in React and Next.js. Proven
            track record of successfully delivering user-centric web
            applications, including hospital management systems, HRM, ERP
            solutions, and document management systems. Adept at collaborating
            with backend teams to ensure seamless integration and enhancing user
            experience through intuitive design. Skilled in developing
            efficient, responsive interfaces and implementing secure
            authentication systems.
          </p>
          <Box mt={3}>
            <a href={resume} download="Raton_Kumar_Das.pdf">
              <button className="resume_btn">Download Resume</button>
            </a>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default About;
